import { TableColumn } from "components/table/Table";
import TableTruncate from "components/table/renderComponents/TableTruncate";
import { getDataBasedOnLang } from "utils/getDataBasedOnLang";

export interface Data {
  _id: string;
  title: {
    en: string;
    tr: string;
  };
  listOrderNumber: number;
  createdAt: string;
}

export const columns: TableColumn<Data>[] = [
  {
    key: "_id",
    label: "id",
    sortable: true,
    render: (item: Data) => <TableTruncate text={item._id} withCopy />,
  },
  {
    key: "title",
    label: "title",
    sortable: true,
    render: (item: Data) => getDataBasedOnLang(item.title),
  },
  {
    key: "listOrderNumber",
    label: "listOrderNumber",
    sortable: true,
    render: (item: Data) => <p>{item.listOrderNumber}</p>,
  },
  {
    key: "createdAt",
    label: "createdAt",
    sortable: true,
  },
];
